import { Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import QrCode2RoundedIcon from '@mui/icons-material/QrCode2Rounded';
import StatCard from './StatCard';

function CryptoOrdersButton() {
  const { t }: { t: any } = useTranslation();
  const navigate = useNavigate();
  return (
    <StatCard
      icon={<QrCode2RoundedIcon />}
      label={t('New transaction')}
      footer={
        <Typography variant="body2" color="text.secondary">
          {t('Create a crypto payment request and share it with your customer.')}
        </Typography>
      }
    >
      <Button variant="contained" color="primary" startIcon={<AddRoundedIcon />} onClick={() => navigate('/cryptoOrders/create')}>
        {t('Create transaction')}
      </Button>
    </StatCard>
  );
}

export default CryptoOrdersButton;
